import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from 'src/app/shared/constants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QuotationService {

  constructor(private http: HttpClient) {}

  Baseurl(): string {
    return Constants.BASE_URL;
  }

getSalesExecutives(locationId: number): Observable<any> {
  return this.http.get<any>(`${this.Baseurl()}Masters/GetEmployeeSalesExecutive/${locationId}`);
}

postItemDetails(payload: any): Observable<any> {
  return this.http.post<any>(`${this.Baseurl()}masters/PostItemDetails`, payload);
}

  private apiUrl = Constants.BASE_URL + 'Quotation/PostQuotation';

  saveQoutation(data: any): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    });
    return this.http.post(this.apiUrl, data, { headers });
  }
  getSalesSource(locationId){
    return this.http.get<any>(this.Baseurl()+ 'Masters/GetSalesSource/'+locationId);
  }
getQuotoations(ID: number) {
  return this.http.get<any>(Constants.BASE_URL + 'Quotation/GetAllQuotations/' + ID, {observe: 'response'});
}
  getStandardTerms() {
    return this.http.get<any>(Constants.BASE_URL +'Quotation/GetStandardTerms', { observe: 'response' });
  }
  getReferences() {
    return this.http.get<any>(Constants.BASE_URL +'Masters/GetBusinessReference/1', { observe: 'response' });
  }
  getQuotationByID(inputData) {
    return this.http.post<any>(Constants.BASE_URL + 'Quotation/GetQuotation',inputData,{observe:'response'});
  }
  getQuotationsByCustomer(locationId: number, mobileNumber: string): Observable<any> {
    const apiUrl = this.Baseurl() + 'Quotation/GetAllQuotationsByCustomer';
    const requestBody = {
      LocationID: locationId,
      CustomerMobileNumber: mobileNumber
    };
    return this.http.post(apiUrl, requestBody, { observe: 'response' });
  }
  private apiUrl1 = Constants.BASE_URL + 'Quotation';
  getQuotation(request: { LocationID: number, ID: number }): Observable<any> {
    const url = `${this.apiUrl1}/GetQuotation`;
    return this.http.post(url, request);
  }
  getQuotationItems(request: { LocationID: number; ID: number }): Observable<any> {
    return this.http.post(`${this.apiUrl1}/GetQuotationItems`, request);
  }
   getNetSalesPerEmployee(payload: { LocationID: number, YearNo: number, FromDate: string, ToDate: string }): Observable<any> {
    const url = this.Baseurl() + 'SalesReport/GetNetSalesPerEmployee';
    return this.http.post(url, payload);
  }
}
